import { render } from "./DetailsWidget.vue?vue&type=template&id=7320db4a"
import script from "./DetailsWidget.vue?vue&type=script&lang=js"
export * from "./DetailsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__